export const Carousel = () => import('../../../../components/Carousel.vue' /* webpackChunkName: "components/carousel" */).then(c => wrapFunctional(c.default || c))
export const ConfirmationPopup = () => import('../../../../components/ConfirmationPopup.vue' /* webpackChunkName: "components/confirmation-popup" */).then(c => wrapFunctional(c.default || c))
export const FavoriteItem = () => import('../../../../components/FavoriteItem.vue' /* webpackChunkName: "components/favorite-item" */).then(c => wrapFunctional(c.default || c))
export const Footer = () => import('../../../../components/Footer.vue' /* webpackChunkName: "components/footer" */).then(c => wrapFunctional(c.default || c))
export const GridItem = () => import('../../../../components/GridItem.vue' /* webpackChunkName: "components/grid-item" */).then(c => wrapFunctional(c.default || c))
export const Header = () => import('../../../../components/Header.vue' /* webpackChunkName: "components/header" */).then(c => wrapFunctional(c.default || c))
export const IconLink = () => import('../../../../components/IconLink.vue' /* webpackChunkName: "components/icon-link" */).then(c => wrapFunctional(c.default || c))
export const Loader = () => import('../../../../components/Loader.vue' /* webpackChunkName: "components/loader" */).then(c => wrapFunctional(c.default || c))
export const Map = () => import('../../../../components/Map.vue' /* webpackChunkName: "components/map" */).then(c => wrapFunctional(c.default || c))
export const NotificationBar = () => import('../../../../components/NotificationBar.vue' /* webpackChunkName: "components/notification-bar" */).then(c => wrapFunctional(c.default || c))
export const NotificationContainer = () => import('../../../../components/NotificationContainer.vue' /* webpackChunkName: "components/notification-container" */).then(c => wrapFunctional(c.default || c))
export const Salle = () => import('../../../../components/Salle.vue' /* webpackChunkName: "components/salle" */).then(c => wrapFunctional(c.default || c))
export const UserProfile = () => import('../../../../components/UserProfile.vue' /* webpackChunkName: "components/user-profile" */).then(c => wrapFunctional(c.default || c))
export const LightCarousel = () => import('../../../../components/lightCarousel.vue' /* webpackChunkName: "components/light-carousel" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
